import { useEffect } from 'react';

interface DownloadModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function DownloadModal({ isOpen, onClose }: DownloadModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleGooglePlay = () => {
    window.open('https://play.google.com/store/apps/details?id=br.com.vitauni&hl=pt_BR', '_blank');
  };

  const handleAppStore = () => {
    window.open('https://apps.apple.com/br/app/vitauni/id6757611955', '_blank');
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="relative bg-white rounded-3xl p-8 md:p-12 max-w-lg w-full shadow-2xl animate-scale-in">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors cursor-pointer"
          aria-label="Fechar"
        >
          <i className="ri-close-line text-2xl text-gray-600"></i>
        </button>

        {/* Icon */}
        <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-[#00A8E8] to-[#E91E63] rounded-3xl flex items-center justify-center">
          <i className="ri-smartphone-line text-4xl text-white"></i>
        </div>

        {/* Title */}
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-3">
          Baixe o VitaUni
        </h2>

        {/* Subtitle */}
        <p className="text-center text-gray-600 mb-8">
          Seu cartão digital de benefícios em saúde está no app
        </p>

        {/* Download Buttons */}
        <div className="space-y-4 mb-6">
          {/* Google Play */}
          <button
            onClick={handleGooglePlay}
            className="w-full bg-black hover:bg-gray-800 text-white py-4 px-6 rounded-2xl font-semibold transition-all flex items-center justify-center gap-3 cursor-pointer group whitespace-nowrap"
          >
            <i className="ri-google-play-fill text-2xl"></i>
            <span>Disponível na Google Play</span>
            <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
          </button>

          {/* App Store */}
          <button
            onClick={handleAppStore}
            className="w-full bg-black hover:bg-gray-800 text-white py-4 px-6 rounded-2xl font-semibold transition-all flex items-center justify-center gap-3 cursor-pointer group whitespace-nowrap"
          >
            <i className="ri-apple-fill text-2xl"></i>
            <span>Disponível na App Store</span>
            <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
          </button>
        </div>

        {/* Info Text */}
        <p className="text-center text-sm text-gray-500">
          Disponível para Android e iOS
        </p>

        {/* Important Note */}
        <div className="mt-6 p-4 bg-gradient-to-r from-[#00A8E8]/10 to-[#E91E63]/10 rounded-xl border border-[#00A8E8]/20">
          <p className="text-sm text-center text-gray-700 font-medium">
            ✨ A assinatura é feita exclusivamente pelo aplicativo
          </p>
        </div>
      </div>
    </div>
  );
}